import React, { useCallback, useEffect, useState } from 'react'
import TableRowCommon from '../../../../../components/table/TableRowCommon';
import { RemoveRedEyeOutlined } from '@mui/icons-material';
import { NavigateFunction, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { dateToView } from '../../../../../utils/date.utils';
import TableCustom from '../../../../../components/table/tableCustom';
import { ButtonPrimary } from '../../../../../components/button/ButtonCustoms';
import { routeName } from '../../../../../routes/routeName';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../../../store/loading/loading.slice';
import { MeetingRoomApi } from '../../../../../api/meeting-room/meeting-room.api';
import { useTranslation } from 'react-i18next';
import { alertActive, swalSuccess } from '../../../../../components/alert/swal';
import OptionsButtonCustom from '../../../../../components/option-button/OptionsButtonCustom';

export default function MeetingParticipants() {
    const navigate: NavigateFunction = useNavigate();
    const [data, setData] = useState<any[]>([]);
    const { id } = useParams();
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const mode = searchParams.get("mode");
    const dispatch = useDispatch();
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("");
    const [sortType, setSortType] = useState<string>("ASC");
    const [tab, setTab] = useState<number>(0)
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy);
        setSortType(sortType);
    };
    const headCells = [
        {
            id: "#",
            width: '200px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: t("MEETING.NO"),
        },
        {
            id: "leave_type_name",
            width: '350px',
            sortable: false,
            disablePadding: false,
            align: "start",
            label: t("MEETING.FULL_NAME"),
        },
        {
            id: "leave_type_name",
            width: '350px',
            sortable: false,
            disablePadding: false,
            align: "start",
            label: t("MEETING.STAFF_ID"),
        },
        {
            id: "leave_type_name",
            width: '250px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: t("MEETING.JOB_TITLE"),
        },
        {
            id: "leave_type_name",
            width: '250px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: t("MEETING.DEPARTMENT"),
        },
        {
            id: "leave_type_name",
            width: '250px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: t("MEETING.MEETING_POSITION"),
        },

        {
            id: "user_updated",
            disablePadding: false,
            align: "center",
            width: '250px',
            label: t("MEETING_POSITION.LAST_UPDATED_BY"),
        },
        {
            id: "last_updated",
            disablePadding: false,
            align: "center",
            width: '250px',
            label: t("MEETING_POSITION.LAST_UPDATED_DATE"),
        },

        {
            id: "action",
            disablePadding: false,
            align: "center",
            width: '200px',
            label: "action",
        },
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1;
        const { id_leave_type, participant_name, meeting_participants_position, position, department, employee_no, modifier_name, modified_date, id_meeting_participants } =
            objData;

        const objRenderData = {
            key: id_leave_type,
            id: no,
            obj: objData,
            columns: [
                {
                    option: "TEXT",
                    align: "center",
                    label: no || "-",
                },
                {
                    option: "TEXT",
                    align: "start",
                    label: participant_name,
                },
                {
                    option: "TEXT",
                    align: "start",
                    label: employee_no,
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: position,
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: department,
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: meeting_participants_position || '-',
                },
                {
                    option: "TEXT",
                    align: "center",
                    disablePadding: true,
                    label: modifier_name || '',
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? dateToView(modified_date) : "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: (
                        <OptionsButtonCustom
                            enableView
                            enableEdit={!mode}
                            enableDelete={!mode}
                            onViewClick={() => {
                                navigate(routeName.cms.ViewMeetingParticipants.replace(':id', `${id}`).replace(':id_participant', `${id_meeting_participants}`))
                            }}

                            onEditClick={() => {
                                navigate(routeName.cms.DetailMeetingParticipants.replace(':id', `${id}`).replace(':id_participant', `${id_meeting_participants}`))
                            }}
                            onDeleteClick={() => {
                                alertActive(t('ยืนยันที่จะลบ หรือไม่?'), '', t('ยืนยัน'), t('ยกเลิก'), () => {
                                    deleteParticipants(id_meeting_participants)
                                })
                            }} />

                    ),
                },
            ],
        };
        return <TableRowCommon {...objRenderData} />;
    };
    const loadData = useCallback(async () => {
        dispatch(setLoading());

        try {
            let condition: any = {};
            // if (page) condition = { ...condition, page: page };
            // if (pageLimit) condition = { ...condition, limit: pageLimit };

            const res = await MeetingRoomApi.listParticipants(condition, id);
            const data = res.data
            if (data?.status < 300) {
                setData(data?.data);
                setPage(data?.data?.meta.currentPage)
                setTotalItems(data?.data?.meta?.totalItems)
                dispatch(unsetLoading());
            } else {
                dispatch(unsetLoading());
            }
        } catch (error) {
            dispatch(unsetLoading());
        }
    }, []);

    useEffect(() => {
        loadData();
    }, [loadData]);

    const deleteParticipants = async (id_participant: any) => {
        const res = await MeetingRoomApi.deleteParticipants(id, id_participant);
        if (res.status < 300) {
            swalSuccess(t('ลบเรียบร้อย'))
            loadData()
        }
    }

    return (
        <section className="w-full mt-10">
            {!mode && <div className='flex items-center justify-end mb-[10px]'>
                <ButtonPrimary
                    onClick={() => {
                        // handleSubmit(inputValueFormStudent.information);
                        navigate(routeName.cms.AddMeetingParticipants.replace(':id', `${id}`))
                    }}
                    mode="add"
                    buttonName={t("MEETING.ADD_MEETING_PARTICIPANT")}
                    btnProps={{
                        width: "250px",
                    }}
                />
            </div>}
            <TableCustom
                tableMinWidth={1440}
                tableFixedWidth
                customScroll
                page={page}
                pageLimit={pageLimit}
                sortBy={sortBy}
                sortType={sortType}
                headCells={headCells}
                rowCount={totalItems}
                rowsData={
                    data.map((data: any, i: any) => {
                        return renderData(data, i);
                    })
                }
                onSort={handleRequestSort}
                setPageLimit={(value: number) => setPageLimit(value)}
                setPage={(value: number) => setPage(value)}
            />
        </section>
    )
}
